var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quick-login"},_vm._l((6),function(i){return _c('input-field',{key:i,attrs:{"id":i,"pattern":"[0-9]{1}","maxlength":"1"},on:{"keyup":_vm.validate}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }